import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initScrollAnimations() {
  // .fade-up - pojedynczy element
  const fadeUpElements = document.querySelectorAll(".fade-up, .fade-up--text");

  fadeUpElements.forEach((el) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 80 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          toggleActions: "play none none none",
        },
      },
    );
  });

  // .fade-up-stagger - dzieci z opóźnieniem
  const staggerContainers = document.querySelectorAll(".fade-up-stagger");

  staggerContainers.forEach((container) => {
    const children = container.children;

    if (children.length === 0) return;

    gsap.fromTo(
      children,
      { opacity: 0, y: 80 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: container,
          start: "top 90%",
          toggleActions: "play none none none",
        },
      },
    );
  });

  // .text-section__image-background - reveal z dołu na górę
  // .text-section__image - reveal z góry na dół
  const textSections = document.querySelectorAll(".text-section");

  textSections.forEach((section) => {
    const background = section.querySelector(".text-section__image-background");
    const image = section.querySelector(".text-section__image");

    if (background) {
      gsap.fromTo(
        background,
        { clipPath: "inset(100% 0 0 0)" },
        {
          clipPath: "inset(0% 0 0 0)",
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        },
      );
    }

    if (image) {
      gsap.fromTo(
        image,
        { clipPath: "inset(0 0 100% 0)" },
        {
          clipPath: "inset(0 0 0% 0)",
          duration: 1,
          ease: "power3.out",
          delay: 0.2,
          scrollTrigger: {
            trigger: section,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        },
      );
    }
  });
}

export { initScrollAnimations };
